import { render, staticRenderFns } from "./CaptureIfYouCan.vue?vue&type=template&id=48229234&scoped=true&"
import script from "./CaptureIfYouCan.vue?vue&type=script&lang=ts&"
export * from "./CaptureIfYouCan.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureIfYouCan.vue?vue&type=style&index=0&id=48229234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48229234",
  null
  
)

export default component.exports